import { BASE_URL_NODE } from "./serviceUrls";

export const UpdateStatus = async (payload) => {
  return fetch(`${BASE_URL_NODE}/web-api/update_status`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  }).then((res) => res.json());
};
